import styled from 'styled-components';
import { fontSize, fontWeight, mediaMax, primaryColor, warningColor } from '@styles/utils';
import FormField from '@shared/modules/form/components/FormField';
import CustomLink from '@shared/components/link/CustomLink';
import { Button } from '@styles/shared/buttons';

export const TicketDeviceContainer = styled.div`
  padding: 40px 0;
  margin: 0 auto;
  width: 100%;
  max-width: 1090px;

  @media screen and (max-width: 1230px) {
    padding: 40px 16px;
  }

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const TicketDeviceContent = styled.div`
  width: 100%;
  max-width: 540px;
`;

export const TicketDeviceTitle = styled.h2`
  ${fontSize.h2};
  font-weight: ${fontWeight.standard};
  color: ${primaryColor(500)};
`;

export const TicketDeviceInput = styled(FormField)`
  padding-top: 40px;

  @media screen and (${mediaMax.tablet}) {
    padding-top: 20px;
  }
`;

export const TicketDeviceLinkContainer = styled.div`
  padding-top: 5px;
`;

export const TicketDeviceLink = styled(CustomLink)`
  font-weight: ${fontWeight.standard};
`;

export const TicketDeviceErrorMessage = styled.p`
  padding-top: 20px;
  color: ${warningColor};
  ${fontSize.large};
  font-weight: ${fontWeight.normal};
`;

export const TicketDeviceActions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TicketDeviceButton = styled(Button)`
  margin-top: 36px;

  &:not(:first-child) {
    margin-left: 20px;
  }
`;
